import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GridModule } from '@progress/kendo-angular-grid';
import { AdminService } from '../admin.service';
import { SimpleLoadingComponent } from '../../shared-components/simple-loading/simple-loading.component';
import { Router } from '@angular/router';
import { State } from '@progress/kendo-data-query';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-kb-change-history',
  templateUrl: './kb-change-history.component.html',
  styleUrl: './kb-change-history.component.scss',
  imports: [
    GridModule,
    MatIconModule,
    MatButtonModule,
    SimpleLoadingComponent,
    MatTooltipModule,
  ],
})
export class KbChangeHistoryComponent implements OnInit {
  private adminService = inject(AdminService);
  private route = inject(Router);

  currentStep: number;
  loading = false;
  public pageSize = 50;
  public pageableData = {
    buttonCount: 5,
    refresh: true,
    alwaysVisible: false,
    pageSizes: [this.pageSize, 100, 200],
  };
  state: State = {};
  kbState: State = {};
  kbSectionState: State = {};
  changeDataActionStyle: string;
  sectionChangeDataContent: string[];
  sectionChangeDataAction: string;
  sectionChangeDataTitle: string;
  tableDisplayData = [];
  tableDisplayHeaders = [];
  kbDisplayData = [];
  kbSectionDisplayData = [];
  kbDataHeaders = [
    {
      DataField: 'kbId',
      Label: 'KB ID',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'date',
      Label: 'Date Changed',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'changeId',
      Label: 'Change ID',
      Hidden: true,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'userid',
      Label: 'Changed By',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'userName',
      Label: 'User Name',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'action',
      Label: 'Action',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
  ];
  kbSectionDataHeaders = [
    {
      DataField: 'action',
      Label: 'Action',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'changeId',
      Label: 'Change ID',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'sectionId',
      Label: 'Section ID',
      Hidden: true,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'sectionName',
      Label: 'Section Name',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
    {
      DataField: 'sectionType',
      Label: 'Section Type',
      Hidden: false,
      Sort: false,
      Group: false,
      SubGroup: '',
      Filter: false,
      FilterType: 'string',
      RespVis: 'xs',
    },
  ];
  selectedKBTitle: string;
  previousPageTitle: string;
  selectedKBDate: string;

  ngOnInit(): void {
    this.getKBs();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getDetailBtnFunction(dataItem) {
    if (this.currentStep === 1) {
      this.getKBSectionDetail(dataItem);
    } else if (this.currentStep === 2) {
      this.getKBSectionChangeDetail(dataItem);
    }
  }

  back(step?: string) {
    switch (step) {
      case 'KB':
        this.currentStep = 2;
        break;

      default:
        break;
    }

    this.sectionChangeDataTitle = null;
    this.sectionChangeDataAction = null;
    this.sectionChangeDataContent = null;

    if (this.currentStep === 3) {
      this.currentStep = 2;
      this.state = this.kbSectionState;
      this.tableDisplayData = this.kbSectionDisplayData;
      this.tableDisplayHeaders = this.kbSectionDataHeaders;
      this.previousPageTitle = 'KBs';
    } else if (this.currentStep === 2) {
      this.currentStep = 1;
      this.state = this.kbState;
      this.tableDisplayData = this.kbDisplayData;
      this.tableDisplayHeaders = this.kbDataHeaders;
    }
  }

  updateFilters(ev) {
    if (this.currentStep === 1) {
      this.kbState.filter = ev;
      this.state = this.kbState;
    }
    if (this.currentStep === 2) {
      this.kbSectionState.filter = ev;
      this.state = this.kbSectionState;
    }
  }

  getKBs() {
    this.currentStep = 1;
    this.loading = true;
    this.state = this.kbState;
    this.adminService.getKBChanges().subscribe(res => {
      {
        this.kbDisplayData = res.results['data'] || res.results;
        this.tableDisplayData = this.kbDisplayData;
        this.tableDisplayHeaders = res.results['headers'] || this.kbDataHeaders;
        this.previousPageTitle = null;
        this.loading = false;
      }
    });
  }

  getKBSectionDetail(dataItem) {
    this.currentStep = 2;
    this.loading = true;
    this.state = this.kbSectionState;
    this.adminService.getKBSectionChanges(dataItem.changeId).subscribe(res => {
      this.kbSectionDisplayData = res.results['data']
        ? res.results['data']
        : res.results;
      this.tableDisplayData = this.kbSectionDisplayData;
      this.tableDisplayHeaders = res.results['headers']
        ? res.results['headers']
        : this.kbSectionDataHeaders;
      this.selectedKBTitle = `${dataItem.kbId}`;
      this.selectedKBDate = `${dataItem.date}`;
      this.previousPageTitle = 'KBs';
      this.loading = false;
    });
  }

  getKBSectionChangeDetail(dataItem) {
    this.currentStep = 3;
    this.loading = true;
    this.adminService
      .getKBSectionChangeData(dataItem.changeId, dataItem.sectionId)
      .subscribe(res => {
        this.tableDisplayHeaders = [];
        this.tableDisplayData = [];
        this.sectionChangeDataTitle = `${dataItem.sectionName}`;
        this.sectionChangeDataAction = `${dataItem.action}`;
        switch (dataItem.action) {
          case 'remove':
            this.changeDataActionStyle = 'negative';
            break;
          case 'add':
            this.changeDataActionStyle = 'positive';
            break;
          case 'modify':
            this.changeDataActionStyle = 'neutral';
            break;

          default:
            break;
        }
        const formattedString = [];
        const splitString = res.results.split('<');
        splitString.forEach(line => {
          if (line) {
            line = `<${line}`;
            formattedString.push(line);
          }
        });
        this.sectionChangeDataContent = formattedString;
        this.previousPageTitle = this.selectedKBTitle;
        this.loading = false;
      });
  }
}
